import { useQuery } from '@tanstack/react-query';
import { routes } from '~/api/routes';
import { useFetch } from '~/hooks';
import { termsAndConditions, termsAndConditionsUserAcceptanceSchema } from '~/schemas/termsAndConditions';

export const termsAndConditionsQueryKeys = {
  getTerms: () => [...termsAndConditionsQueryKeys.root, 'getTerms'],
  root: ['termsAndConditions'],
  termsAcceptance: (userEmail: string) => [...termsAndConditionsQueryKeys.root, 'termsAcceptance', userEmail],
} as const;

export function useGetTermsAndConditions() {
  const { fetchData } = useFetch();
  return useQuery({
    queryFn: () => fetchData(routes.termsAndConditions.getTermsAndConditions, { response: termsAndConditions }),
    queryKey: termsAndConditionsQueryKeys.getTerms(),
  });
}

export function useTermsAndConditionsQuery({ userEmail }: { userEmail: string }) {
  const { fetchData } = useFetch();
  return useQuery({
    queryFn: () =>
      fetchData(routes.termsAndConditions.getTermsAndConditionsUserAcceptance(userEmail), {
        response: termsAndConditionsUserAcceptanceSchema,
      }),
    queryKey: termsAndConditionsQueryKeys.termsAcceptance(userEmail),
  });
}
